(()=>{
 const carousel=document.querySelector('[data-hero-carousel]');
 if(!carousel)return;
 const slides=[...carousel.querySelectorAll('[data-hero-slide]')];
 const previews=carousel.querySelector('[data-hero-previews]');
 const toggle=carousel.querySelector('[data-hero-play]');
 const mobilePagination=carousel.querySelector('[data-hero-mobile-pagination]');
 mobilePagination.replaceChildren(...slides.map((slide,i)=>{
  const button=document.createElement('button');button.type='button';button.dataset.heroPosition=i;
  button.setAttribute('aria-label',`Show ${slide.dataset.title}`);button.append(document.createElement('span'));return button;
 }));
 const motion=matchMedia('(prefers-reduced-motion: reduce)');
 let index=0,timer=null,userPaused=motion.matches,hoverPaused=false,focusPaused=false,touchStart=null;
 let lastSwipe=0;
 function positionMobileArrows(){
  const image=slides[index].querySelector('.hero-art');
  carousel.style.setProperty('--hero-mobile-arrow-y',`${image.getBoundingClientRect().top-carousel.getBoundingClientRect().top+image.getBoundingClientRect().height/2}px`);
 }
 function schedule(){
  clearTimeout(timer);
  toggle.textContent=userPaused?'▶':'Ⅱ';
  toggle.setAttribute('aria-label',userPaused?'Play hero slideshow':'Pause hero slideshow');
  if(!userPaused&&!hoverPaused&&!focusPaused&&!document.hidden)timer=setTimeout(()=>show(index+1,false),7000);
 }
 function show(next,manual=true){
  index=(next+slides.length)%slides.length;
  slides.forEach((slide,i)=>{slide.hidden=i!==index;slide.setAttribute('aria-hidden',String(i!==index))});
  mobilePagination.querySelectorAll('button').forEach((button,i)=>{if(i===index)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current')});
  requestAnimationFrame(positionMobileArrows);
  const focusedTarget=previews.contains(document.activeElement)?document.activeElement.dataset.heroTarget:null;
  previews.replaceChildren(...[1,2,3].map(offset=>{
   const target=(index+offset)%slides.length;
   const source=slides[target].querySelector('.hero-art img');
   const button=document.createElement('button');
   button.type='button';button.dataset.heroTarget=target;
   button.setAttribute('aria-label',`Show ${slides[target].dataset.title}${offset===1?', next slide':''}`);
   button.title=slides[target].dataset.title;
   const image=document.createElement('img');image.src=source.getAttribute('src');image.alt='';image.width=64;image.height=64;
   if(slides[target].dataset.title==='Holiday Dollars Book')image.style.objectPosition='78% center';
   button.append(image);return button;
  }));
  if(focusedTarget!==null){const replacement=previews.querySelector(`[data-hero-target="${focusedTarget}"]`);(replacement||previews.querySelector('button')).focus({preventScroll:true})}
  if(manual)carousel.querySelector('[data-hero-status]').textContent=`${slides[index].dataset.title}, slide ${index+1} of ${slides.length}`;
  schedule();
 }
 carousel.querySelector('[data-hero-prev]').addEventListener('click',()=>show(index-1));
 carousel.querySelector('[data-hero-next]').addEventListener('click',()=>show(index+1));
 toggle.addEventListener('click',()=>{userPaused=!userPaused;focusPaused=false;schedule()});
 previews.addEventListener('click',event=>{const button=event.target.closest('[data-hero-target]');if(button)show(Number(button.dataset.heroTarget))});
 mobilePagination.addEventListener('click',event=>{const button=event.target.closest('[data-hero-position]');if(button)show(Number(button.dataset.heroPosition))});
 carousel.addEventListener('mouseenter',()=>{hoverPaused=true;schedule()});
 carousel.addEventListener('mouseleave',()=>{hoverPaused=false;schedule()});
 carousel.addEventListener('focusin',()=>{focusPaused=true;schedule()});
 carousel.addEventListener('focusout',event=>{if(!carousel.contains(event.relatedTarget)){focusPaused=false;schedule()}});
 carousel.addEventListener('keydown',event=>{
  if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();show(index+(event.key==='ArrowRight'?1:-1))}
 });
 carousel.addEventListener('touchstart',event=>{touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};clearTimeout(timer)},{passive:true});
 carousel.addEventListener('touchend',event=>{if(!touchStart)return;const dx=event.changedTouches[0].clientX-touchStart.x,dy=event.changedTouches[0].clientY-touchStart.y;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.5){lastSwipe=Date.now();show(index+(dx<0?1:-1))}else schedule();touchStart=null},{passive:true});
 carousel.addEventListener('click',event=>{if(Date.now()-lastSwipe<450&&event.target.closest('.hero-image-link')){event.preventDefault();event.stopPropagation()}},true);
 new ResizeObserver(positionMobileArrows).observe(carousel);
 document.addEventListener('visibilitychange',schedule);
 motion.addEventListener('change',event=>{if(event.matches)userPaused=true;schedule()});
 show(0,false);
})();
